import apiClient from '@/api/client';
import { getActiveHospitalId, getActiveClinicId } from '@/constants';

const transformDoctor = (doc) => {
  if (!doc) return null;
  const nameParts = (doc.name || '').replace(/^Dr\.\s*/i, '').split(' ');
  return {
    ...doc,
    firstName: doc.firstName || nameParts[0] || '',
    lastName: doc.lastName || nameParts.slice(1).join(' ') || '',
    status: doc.isActive ? 'active' : (doc.status || 'inactive'),
    registrationNo: doc.licenseNumber || doc.registrationNumber || doc.registrationNo || '',
    phone: doc.phone || doc.contactNumber || '',
    assignedClinics: doc.assignedClinics || ['101'],
    clinics: doc.clinics || [{ id: '101', name: 'Main OPD Clinic' }],
  };
};

export const doctorService = {
  /**
   * GET /pms/hospital/{hospitalId}/doctors
   */
  getAll: async (params = {}, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const res = await apiClient.get(`/hospital/${activeHospId}/doctors`, {
      params: {
        page: (params.page || 1) - 1,
        size: params.limit || 50,
        specialization: params.specialization !== 'all' ? params.specialization : undefined,
        status: params.status !== 'all' ? params.status : undefined,
      },
    });

    const items = (res.content || res.data || []).map(transformDoctor);
    let filtered = items;
    if (params.search) {
      const s = params.search.toLowerCase();
      filtered = items.filter(
        (d) =>
          d.name?.toLowerCase().includes(s) ||
          d.specialization?.toLowerCase().includes(s) ||
          d.registrationNo?.toLowerCase().includes(s)
      );
    }

    return {
      data: filtered,
      total: res.totalElements !== undefined ? res.totalElements : filtered.length,
    };
  },

  /**
   * GET /pms/hospital/{hospitalId}/doctors/{doctorId}
   */
  getById: async (id, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const res = await apiClient.get(`/hospital/${activeHospId}/doctors/${id}`);
    return transformDoctor(res.data || res);
  },

  /**
   * GET /pms/hospital/{hospitalId}/clinic/{clinicId}/doctors/{doctorId}/slots?date=YYYY-MM-DD
   */
  getSchedule: async (doctorId, date, clinicId, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const activeClinicId = getActiveClinicId(clinicId);
    const res = await apiClient.get(`/hospital/${activeHospId}/clinic/${activeClinicId}/doctors/${doctorId}/slots`, {
      params: { date },
    });
    const data = res.data || res;
    return {
      schedule: {
        start: data.startTime || '09:00',
        end: data.endTime || '17:00',
        slotDuration: data.slotDurationMinutes || 30,
      },
      bookedSlots: data.bookedSlots || [],
      availableSlots: data.availableSlots || [],
      isAvailable: data.available,
    };
  },

  /**
   * POST /pms/hospital/{hospitalId}/doctors
   */
  create: async (data, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const res = await apiClient.post(`/hospital/${activeHospId}/doctors`, data);
    return transformDoctor(res.data || res);
  },

  /**
   * PUT /pms/hospital/{hospitalId}/doctors/{doctorId}
   */
  update: async (id, data, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const res = await apiClient.put(`/hospital/${activeHospId}/doctors/${id}`, data);
    return transformDoctor(res.data || res);
  },
};

export default doctorService;
